import React from 'react';
import { connect } from 'react-redux';
import PageHeaderWrapper from '../../components/PageHeaderWrapper';
import Request from '../../request';
import { Card, Row, Col, Select } from 'antd';
import { TableComp } from 'sz-react-utils';
import moment from 'moment';

const { Option } = Select;
var totalCurrentData = null;


class CounsellorConversionReport extends React.Component {
    state = {
        branchName: null,
        branchId: null,
        dateKeys: null,
        lastSixYears: [],
        loading: false,
        dateFilter: {
            from: moment().startOf("year").toDate(),
            to: moment().endOf("year").toDate(),
        }
    }


    prepareTableData = (counsellors) => {
        return Object.values(counsellors).map((item) => ({
            key: item.counsellorId,
            counsellorDetails: item.counsellorDetails || "Unknown",
            counsellingCount: item.counsellingCount,
            registrationCount: item.registrationCount,
            conversionRatio: item.counsellingCount > 0
                ? ((item.registrationCount / item.counsellingCount) * 100).toFixed(2) + "%"
                : "0%",
        }));
    };



    constructor(props) {
        super(props)
        this.table = React.createRef();

    }

    apiRequest = (params = {}) => {
        return new Promise(async (resolve) => {
            let { branchId, dateFilter } = this.state;
            params.branchId = branchId;
            this.setState({ loading: true });
            let response = await Request.getCounsellingConversionReport({ ...params, ...dateFilter });
            const dateKeys = Object.keys(response.data || {});
            this.setState({ dateKeys, data: response.data, loading: false });
            resolve(response);
        });
    };


    handleDateChange = (value, filterName) => {
        let dateFilter = null;
        let { year } = this.state;
        // Filter by Year
        if (filterName === "year") {
            dateFilter = {
                from: moment(value, "YYYY").startOf("year").toDate(),
                to: moment(value, "YYYY").endOf("year").toDate(),
            };
        }


        // Reset date filter
        if (value === null) {
            dateFilter = null;
        }

        this.setState({ dateFilter }, () => {
            this.apiRequest();
        });
    };

    async componentDidMount() {
        try {
            const queryParams = new URLSearchParams(window.location.search);
            const branchId = queryParams.get("branchId");

            const { doc } = await Request.getBranch(branchId);
            const currentYear = new Date().getFullYear();
            const lastSixYears = Array.from({ length: 6 }, (_, i) => currentYear - i);
            if (doc && doc.branchName) {
                this.setState({ branchName: doc.branchName, branchId, lastSixYears }, () => {
                    this.apiRequest();
                });
            } else {
                this.setState({ branchId, lastSixYears }, () => {
                    this.apiRequest();
                });
            }
        } catch (error) {
            console.error("Error parsing branchId:", error);
        }
    }

    render() {
        const { branchName, lastSixYears, dateKeys, data } = this.state;
        const columns = [
            {
                title: "Counsellor Name",
                dataIndex: "counsellorDetails",
                key: "counsellorDetails",
            },
            {
                title: `Counselling Count`,
                dataIndex: "counsellingCount",
                key: "counsellingCount",
            },
            {
                title: `Registration Count`,
                dataIndex: "registrationCount",
                key: "registrationCount",
            },
            {
                title: `Conversion Ratio`,
                dataIndex: 'conversionRatio',
                key: 'conversionRatio'
            }
        ];

        const sortedDateKeys = dateKeys
            ? dateKeys.sort((a, b) => moment(a).valueOf() - moment(b).valueOf())
            : [];
        return (
            <PageHeaderWrapper title={`Counsellor Conversion Report - ${branchName}`}>
                <Card bordered={true}>
                    <Row>
                        <Col span={6}>
                            <label>Search By Year</label>
                            <Select
                                style={{ width: "100%" }}
                                placeholder="Select year"
                                defaultValue="2025"
                                onChange={(value) => this.setState({ year: value }, () => { this.handleDateChange(value, "year") })}
                            >
                                {lastSixYears.map((year) => (
                                    <Option key={year} value={year}>
                                        {year}
                                    </Option>
                                ))}
                            </Select>
                        </Col>
                    </Row>
                </Card>
                <Card bordered={true} loading={this.state.loading}>
                    {sortedDateKeys.map((dateKey) => {
                        const currentData = data[dateKey];
                        const tableData = this.prepareTableData(currentData.counsellors);
                        totalCurrentData = currentData;
                        return (
                            <Card
                                key={dateKey}
                                title={`Data for ${moment(currentData.date).format("MMM YYYY")}`}
                                style={{ marginBottom: "20px" }}
                            >
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <p>
                                        <strong>Counsellings:</strong> {currentData.inquiriesCount}
                                    </p>
                                    <p>
                                        <strong>Registrations:</strong> {currentData.registrationsCount}
                                    </p>
                                    <p>
                                        <strong>Conversion Ratio:</strong> {currentData.registrationsCount && currentData.inquiriesCount ? ((currentData.registrationsCount / currentData.inquiriesCount) * 100).toFixed(2) + "%" : "0.00%"}
                                    </p>
                                </div>
                                <TableComp
                                    columns={columns}
                                    dataSource={tableData}
                                    pagination={false}
                                    bordered
                                />
                                <table style={{ width: "100%" }}>
                                    <thead>
                                        <tr>
                                            <th>Total Counsellings</th>
                                            <th>Total Registrations</th>
                                            <th>Conversion Ratio</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{currentData.inquiriesCount}</td>
                                            <td>{currentData.registrationsCount}</td>
                                            <td>{currentData.registrationsCount && currentData.inquiriesCount ?
                                                ((currentData.registrationsCount / currentData.inquiriesCount) * 100).toFixed(2) + "%"
                                                : "0.00%"}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Card>
                        );
                    })}
                    {/* <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        pagination={false}
                        bordered
                    /> */}
                </Card>
            </PageHeaderWrapper >
        );
    }
}

const mapStateToProps = ({ global }) => ({
    categories: global.categories,
    loading: global.buttonLoading
});

export default connect(mapStateToProps)(CounsellorConversionReport);
